import type { ReactElement } from 'react';
import { useMemo } from 'react';

import { OperationHistory } from '@/components/common/OperationHistory';
import type { Task } from '@/types';

import { mapTaskEvent, useTaskHistoryConfig } from './taskHistoryConfig';

interface TaskHistoryProps {
  task: Task;
}

export const TaskHistory = ({ task }: TaskHistoryProps): ReactElement => {
  const config = useTaskHistoryConfig();
  const events = useMemo(
    () => (task.history ?? []).map(mapTaskEvent),
    [task.history]
  );

  return <OperationHistory events={events} config={config} showFilters />;
};
